<ng-container *transloco="let t">
    @if (event) {
    <div class="event-list-item mb-4">
      <app-my-upcoming-heading [event]="event" [countries]="countries" [languages]="languages"
                                [type]="MyUpcomingHeadingType.EVENT" (onClick)="expand()"/>

      @if (isExpanded) {
        <div class="race-list-item" @toBottom>
            @for (race of event.racesList;track race) {
            <app-my-upcoming-race [race]="race" [languages]="languages" [countries]="countries"
                                 [event]="event"></app-my-upcoming-race>
            }
    </div>

    }</div>


    }
</ng-container>
